import React from "react";
import { genURL, gengetURLTEST } from '../_getjson';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import axios from 'axios'
require('./../_css/PopUpOther.css');

export default class PopUpOther extends React.Component {
    constructor(props) {
        super(props);
        this.Search = React.createRef();
        this.state = {
            type: this.props.type,
            col: [],
            rows: [],
            // valueRetuen: "",
            Htext: "",
            SHtype: 3,
            casschkbox: "far fa-square",
            casschkboxs: false,
            ckbox_length: 0,
        }
    }
    GetformatTimestamp = (date) => {
        if (date) {
            var myDate = new Date(date);
            var date1 = myDate.getDate(); if (myDate.getDate() < 10) { date = "0" + myDate.getDate(); }
            var month = (myDate.getMonth() + 1); if ((myDate.getMonth() + 1) < 10) { month = "0" + (myDate.getMonth() + 1); }
            var year = myDate.getFullYear() + 543;
            return date1 + "/" + month + "/" + year;
        } else {
            return "";
        }
    }
    Get_Data = (event) => {
        var dataArray = [];
        this.setState({ sh_Deposit: true });
        var dataArray = [];
        var Url = "";
        var DOCNO
        if (event === "ARInvDebt") {
            DOCNO = this.Search.current.value;
            Url = "CSSTKMOVEREQ/Getdataforsubpupup?Docno=" + DOCNO;
        } else if (event === "ARInvDebt1") {
            Url = "CSSTKMOVEREQ/Getdataforsubpupup?Docno=" + this.props.P_DOCNO;
        } else if (event.key === "Enter") {
            DOCNO = (event.target.value);
            Url = "CSSTKMOVEREQ/Getdataforsubpupup?Docno=" + DOCNO;
        } else {
            return //--------------- Exit เมื่อไม่เข้าเงือนไขไหนเลย
        }
        console.log(genURL(Url));
        axios.get(genURL(Url), { timeout: 60000 }).then(async (res) => {
            if (res !== "" && res.data.length > 0) {
                for (var i = 0; i < res.data.length; i++) {
                    dataArray[i] = await {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        Col5: res.data[i].QUANTITY,
                        Col6: res.data[i].WAREHOUSE,
                        Col7: res.data[i].LOCATION,
                        Col8: res.data[i].WAREHOUSEIN,
                        Col9: res.data[i].LOCATIONIN,
                        Col10: res.data[i].UNITCODE,
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFQTY: res.data[i].REFQTY,
                        STOCKTYPE: res.data[i].STOCKTYPE,
                        SB: "0"
                    }
                }
                await this.setState({ rows: dataArray });
            } else {
                await this.setState({ rows: dataArray });
            }
        }).catch(error => {
            console.log(error);
        });
        this.setState({ Htext: "เลือกรายการย่อย" });
    }
    componentDidMount() {
        var dataArray = [];
        this.setState({ sh_Deposit: true });
        console.log(this.props.P_DOCNO);
        var Url = "CSSTKMOVEREQ/Getdataforsubpupup?Docno=" + this.props.P_DOCNO;
        console.log(genURL(Url));
        axios.get(genURL(Url), { timeout: 60000 }).then(async (res) => {
            if (res !== "" && res.data.length > 0) {
                for (var i = 0; i < res.data.length; i++) {
                    dataArray[i] = await {
                        number: i + 1,
                        Col1: res.data[i].DOCNO,
                        Col2: res.data[i].PRODUCTCODE,
                        Col3: res.data[i].PRODUCTNAME,
                        Col4: res.data[i].UNITNAME,
                        Col5: res.data[i].QUANTITY,
                        Col6: res.data[i].WAREHOUSE,
                        Col7: res.data[i].LOCATION,
                        Col8: res.data[i].WAREHOUSEIN,
                        Col9: res.data[i].LOCATIONIN,
                        Col10: res.data[i].UNITCODE,
                        REFDOCNO: res.data[i].REFDOCNO,
                        REFQTY: res.data[i].REFQTY,
                        STOCKTYPE: res.data[i].STOCKTYPE,
                        SB: "0"
                    }
                }
                await this.setState({ rows: dataArray });
            } else {
                await this.setState({ rows: dataArray });
            }
        }).catch(error => {
            console.log(error);
        });
        this.setState({ Htext: "เลือกรายการย่อย" });
    }

    cellcheckbok = (cell, row, enumObject, rowIndex) => {
        var btn = this.state.rows[rowIndex].SB;
        var btnShow;
        switch (btn) {
            case "0": btnShow = <span>
                <i className="far fa-square " onClick={this.Update_Status.bind(null, rowIndex, "1")}> </i>
            </span>;
                break;
            case "1": btnShow = <span>
                <i className="far fa-check-square" onClick={this.Update_Status.bind(null, rowIndex, "0")}>  </i>
            </span>;
                break;
            default: btnShow = <span><i className="">  </i></span>;

        }
        return (<div>{btnShow}</div>)
    }
    Update_Status = (Row, Status) => {
        var dataArray = this.state.rows;
        if (Status === "ALL") {
            if (this.state.casschkboxs === false) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                for (let i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "1";
                }
                this.setState({ row: dataArray });

            } else {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: !this.state.casschkboxs });
                for (let i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                    dataArray[i].SB = "0";
                }
                this.setState({ row: dataArray });
            }
        } else {

            if (Status === "0") {
                this.setState({ casschkbox: "far fa-square" });
                this.setState({ casschkboxs: false });
            }
            dataArray[Row].SB = Status;
            this.setState({ rows: dataArray });


            var sb_length = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].DOCNO; i++) {
                if (this.state.rows[i].SB === 1) { sb_length = sb_length + 1; }
            }
            if (sb_length === this.state.rows.length) {
                this.setState({ casschkbox: "far fa-check-square" });
                this.setState({ casschkboxs: true });
            }
        }
    }


    onSelectRow = async (data, col, id) => {
        // this.setState({ valueRetuen: data.code });
        var reData = [];
        if (col > 1) {
            //เท่ากับเลือกรายการเมื่อคลิกแถว
            var dataArray = this.state.rows;
            dataArray[id].SB = "1";
            this.setState({ rows: dataArray });
            //------------------------
            var sb_length = 0;
            var j = 0;
            for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
                if (this.state.rows[i].SB === "1") {
                    sb_length = sb_length + 1;
                    reData[j] = await {
                        Col1: this.state.rows[i].Col2,
                        Col2: this.state.rows[i].Col3,
                        Col3: this.state.rows[i].Col6,
                        Col4: this.state.rows[i].Col7,
                        Col5: this.state.rows[i].Col4,
                        Col6: this.state.rows[i].Col5,
                        Col7: this.state.rows[i].Col8,
                        Col8: this.state.rows[i].Col9,
                        Col9: this.state.rows[i].Col1,
                        Col10: this.state.rows[i].Col10,
                        REFDOCNO: this.state.rows[i].REFDOCNO,
                        REFQTY: this.state.rows[i].REFQTY,
                        STOCKTYPE: this.state.rows[i].STOCKTYPE,
                    }
                    j = j + 1;
                }
            }
            if (reData.length === sb_length) {
                await this.props.Get_PopUpSELSTKMOVEREQSub(reData);
            }
        }
    }
    onSubmit = async () => {
        var reData = [];
        var sb_length = 0;
        var j = 0;
        for (var i = 0; i < this.state.rows.length && this.state.rows[i].Col1; i++) {
            if (this.state.rows[i].SB === "1") {
                sb_length = sb_length + 1;
                reData[i] = await {
                    Col1: this.state.rows[i].Col2,
                    Col2: this.state.rows[i].Col3,
                    Col3: this.state.rows[i].Col6,
                    Col4: this.state.rows[i].Col7,
                    Col5: this.state.rows[i].Col4,
                    Col6: this.state.rows[i].Col5,
                    Col7: this.state.rows[i].Col8,
                    Col8: this.state.rows[i].Col9,
                    Col9: this.state.rows[i].Col1,
                    Col10: this.state.rows[i].Col10,
                    REFDOCNO: this.state.rows[i].REFDOCNO,
                    REFQTY: this.state.rows[i].REFQTY,
                    STOCKTYPE: this.state.rows[i].STOCKTYPE,
                }
                j = j + 1;
            }
        }
        if (reData.length === sb_length) {
            await this.props.Get_PopUpSELSTKMOVEREQSub(reData);
        }
    };
    render() {
        return (
            <div className='popup' style={{ 'z-index': '100' }} >
                <div className='popup_inner'> {/* _arinvdebt divBox */}
                    {this.props.Data}
                    <div className="PopUpOtherDivH" align="left">
                        <div className="PopUpOtherDivH1"><i className="fas fa-at" > {this.state.Htext} </i></div>
                        <div className="PopUpOtherDivH2"><i className="fas fa-times" onClick={this.props.closePopup}></i></div>
                    </div>
                    <div className="panel-body divTable" align="right">
                        <div className=" form-group input-group col-xs-12 col-sm-6 col-md-6 col-lg-6" >
                            <input id="id1" type="text" className="form-control" ref={this.Search} onKeyPress={this.Get_Data.bind(null)}  />
                            <span id="iconsearch" className="input-group-addon icon"><i className="fas fa-search" onClick={() => { this.Get_Data("ARInvDebt") }}></i></span>
                            <span className="input-group-addon txt-img icon"> <i className="fas fa-sync-alt" onClick={() => { this.Get_Data("ARInvDebt1") }}></i></span>
                        </div>
                        <div style={{ marginTop: "10px" }}>
                            <BootstrapTable
                                data={this.state.rows}
                                options={{
                                    onRowClick: this.onSelectRow,
                                    noDataText: "ไม่พบข้อมูลที่ค้นหา",
                                }}
                                height="580"
                                hover condensed >
                                <TableHeaderColumn columnClassName="columnAll columnID" className="columnNumber" dataAlign="center" width="35" dataField='number' isKey><div onClick={this.props.closePopup}><i className="fas fa-reply-all"  ></i> </div></TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='SB' editable={false} dataAlign="center" dataFormat={this.cellcheckbok.bind(this)} > <div onClick={this.Update_Status.bind(null, "", "ALL")} > <i className={this.state.casschkbox}> </i> </div> </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col1'> ใบขอโอน </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col2' > รหัสสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col3' > ชื่อสินค้า </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col4' dataAlign="left" > หน่วย </TableHeaderColumn>
                                <TableHeaderColumn columnClassName="columnAll" className="columnNumber" width="80" dataField='Col5' dataAlign="left"> ปริมาณ </TableHeaderColumn>
                                <TableHeaderColumn dataField='Col6' hidden>  </TableHeaderColumn>
                                <TableHeaderColumn dataField='Col7' hidden>  </TableHeaderColumn>
                                <TableHeaderColumn dataField='Col8' hidden>  </TableHeaderColumn>
                                <TableHeaderColumn dataField='Col9' hidden>  </TableHeaderColumn>
                                <TableHeaderColumn dataField='REFDOCNO' hidden>  </TableHeaderColumn>
                                <TableHeaderColumn dataField='QUANTITY' hidden>  </TableHeaderColumn>
                                <TableHeaderColumn dataField='STOCKTYPE' hidden>  </TableHeaderColumn>
                            </BootstrapTable>
                        </div>
                        {this.state.TableHidden ? ("") : (
                            <button className="PUSDbtn" onClick={this.props.closePopup} >
                                <i className="fas fa-reply-all"> กลับ </i>
                            </button>
                        )}
                        <button className="PUSDbtn" onClick={this.onSubmit}>
                            <i className="fas fa-check"> ตกลง </i>
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}